// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._402_form402-container__jy7gB {
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  color: #000;
  line-height: 1.6;
  direction: ltr;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 1200px;
  margin: 20px auto;
}
._402_form402-container__jy7gB ._402_tab-navigation__jNXUi {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 2px solid #e9ecef;
  background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
._402_form402-container__jy7gB ._402_tab-navigation__jNXUi ._402_tab-button__GeA8c {
  flex: 1 1;
  padding: 20px 30px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  font-family: "Noto Sans Devanagari", Arial, sans-serif;
}
._402_form402-container__jy7gB ._402_tab-navigation__jNXUi ._402_tab-button__GeA8c:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transform: translateY(-2px);
}
._402_form402-container__jy7gB ._402_tab-navigation__jNXUi ._402_tab-button__GeA8c._402_active__Jp02j {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  box-shadow: inset 0 -3px 0 #fff;
}
._402_form402-container__jy7gB ._402_tab-navigation__jNXUi ._402_tab-button__GeA8c._402_active__Jp02j::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #fff;
  border-radius: 2px;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 {
  padding: 30px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  margin-bottom: 30px;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 h2 {
  text-align: center;
  color: #2c3e50;
  font-size: 2rem;
  margin-bottom: 30px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 20px;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  border-color: #0467a0;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU h3 {
  color: #2c3e50;
  font-size: 1.3rem;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 10px;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD {
  position: relative;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD input[type=file] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 2;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP {
  display: block;
  cursor: pointer;
  width: 100%;
  height: 200px;
  border: 3px dashed #dee2e6;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background: #f8f9fa;
  position: relative;
  overflow: hidden;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP:hover {
  border-color: #667eea;
  background: #f0f4ff;
  transform: scale(1.02);
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-placeholder__2XED6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 1.1rem;
  font-weight: 500;
  text-align: center;
  padding: 20px;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-placeholder__2XED6 span {
  font-size: 2rem;
  margin-bottom: 10px;
  opacity: 0.7;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  position: relative;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV ._402_signature-image__LDBel {
  max-width: 100%;
  max-height: 120px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  border: 2px solid #e9ecef;
  background: white;
  padding: 5px;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV p {
  color: #495057;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  margin: 0;
  word-break: break-word;
  max-width: 100%;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV ._402_delete-signature-btn__FL-t9 {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff4444;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease;
  z-index: 10;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV ._402_delete-signature-btn__FL-t9:hover {
  background: #cc0000;
}
._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV ._402_delete-signature-btn__FL-t9:focus {
  outline: none;
}
._402_form402-container__jy7gB ._402_header__V1raK {
  margin-bottom: 30px;
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_logo__aI4Yu {
  flex-shrink: 0;
  margin-top: 10px;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_logo__aI4Yu ._402_logoImage__tFMe6 {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_right__Yj5kK {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  font-weight: bold;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_clear__x1n\\+p {
  clear: both;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye {
  text-align: center;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  margin-left: -180px; /* Shift content to the left */
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p {
  margin: 3px 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p._402_universityName__XWwb6 {
  font-size: 18px;
  font-weight: bold;
  margin: 5px 0;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p._402_officeName__bgP4G {
  font-size: 16px;
  font-weight: normal;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p._402_officeName__bgP4G input {
  font-size: 16px;
  font-weight: normal;
  text-align: center;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p._402_officeAddress__TRGCw {
  font-size: 16px;
  font-weight: normal;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p._402_officeAddress__TRGCw input {
  font-size: 16px;
  font-weight: normal;
  text-align: center;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p._402_officeCode__dyBTw {
  font-size: 16px;
  font-weight: normal;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p._402_officeCode__dyBTw span {
  white-space: nowrap;
}
._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye p._402_officeCode__dyBTw input {
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  min-width: 30px !important;
  max-width: 30px !important;
  width: 30px !important;
}
._402_form402-container__jy7gB ._402_header__V1raK p {
  margin: 8px 0;
  font-size: 14px;
}
._402_form402-container__jy7gB ._402_mainTitle__8iTpY {
  text-align: center;
  margin: 30px 0;
}
._402_form402-container__jy7gB ._402_mainTitle__8iTpY h1 {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: #000;
}
._402_form402-container__jy7gB ._402_formSection__r2VTK {
  margin: 20px 0;
}
._402_form402-container__jy7gB ._402_formSection__r2VTK p {
  margin: 12px 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}
._402_form402-container__jy7gB input[type=text] {
  border: none;
  border-bottom: 1px solid #000;
  min-width: 80px;
  max-width: 400px;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  text-align: left;
  margin: 0 2px;
  padding: 2px 4px;
  overflow: visible;
  white-space: nowrap;
  transition: border-bottom 0.2s ease, width 0.2s ease;
  width: auto;
}
._402_form402-container__jy7gB input[type=text]:focus {
  outline: none;
  border-bottom-color: #007bff;
}
._402_form402-container__jy7gB input[type=text]:not(:placeholder-shown) {
  border-bottom: none;
}
._402_form402-container__jy7gB input[type=text]._402_underline__Zj3G\\+ {
  border-bottom: 1px solid #000;
  min-width: 120px;
  max-width: 500px;
  flex: 1 1;
}
._402_form402-container__jy7gB input[type=text]._402_underline__Zj3G\\+:not(:placeholder-shown) {
  border-bottom: none;
}
._402_form402-container__jy7gB ._402_underline__Zj3G\\+ {
  border-bottom: 1px solid #000;
  width: 100%;
  margin: 10px 0;
}
._402_form402-container__jy7gB ._402_table__wO45p {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
}
._402_form402-container__jy7gB ._402_table__wO45p th, ._402_form402-container__jy7gB ._402_table__wO45p td {
  border: 1px solid #000;
  padding: 10px;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
}
._402_form402-container__jy7gB ._402_table__wO45p th {
  background-color: #f2f2f2;
  font-weight: bold;
}
._402_form402-container__jy7gB ._402_table__wO45p tbody tr {
  height: 40px;
}
._402_form402-container__jy7gB ._402_table__wO45p input[type=text] {
  width: 100%;
  box-sizing: border-box;
  min-width: auto;
  margin: 0;
  border: none;
  text-align: center;
}
._402_form402-container__jy7gB ._402_signature__zT7Ao {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
._402_form402-container__jy7gB ._402_signature__zT7Ao div {
  width: 30%;
  text-align: left;
}
._402_form402-container__jy7gB ._402_signature__zT7Ao ._402_signature-display__60l0a {
  margin-top: 10px;
  text-align: center;
}
._402_form402-container__jy7gB ._402_signature__zT7Ao ._402_signature-display__60l0a img {
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  padding: 2px;
}
._402_form402-container__jy7gB ._402_page-number__xZZKY {
  text-align: center;
  margin-top: 50px;
  font-size: 12px;
  color: #666;
}
._402_form402-container__jy7gB p {
  margin: 5px 0;
}
._402_form402-container__jy7gB ._402_form-section__B9-K3 {
  margin-bottom: 20px;
}
._402_form402-container__jy7gB ._402_total-section__i7kdi {
  margin-top: 10px;
}
._402_form402-container__jy7gB ._402_notes__zevqe {
  font-size: 12px;
  margin-top: 10px;
}
._402_form402-container__jy7gB ._402_deip__\\+j4Ag {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
._402_form402-container__jy7gB ._402_ddd__lCA6x {
  border: 1px solid #000;
  padding: 4px;
}
._402_form402-container__jy7gB ._402_file-upload-section__wFJBR {
  margin: 30px 0;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
}
._402_form402-container__jy7gB ._402_file-upload-section__wFJBR h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 18px;
  text-align: center;
}
._402_form402-container__jy7gB ._402_file-upload-section__wFJBR ._402_upload-grid__mQ-6R {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}
._402_form402-container__jy7gB ._402_file-upload-section__wFJBR ._402_upload-grid__mQ-6R ._402_upload-item__S4T88 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
._402_form402-container__jy7gB ._402_file-upload-section__wFJBR ._402_upload-grid__mQ-6R ._402_upload-item__S4T88 label {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}
._402_form402-container__jy7gB ._402_file-upload-section__wFJBR ._402_upload-grid__mQ-6R ._402_upload-item__S4T88 input[type=file] {
  display: none;
}
._402_form402-container__jy7gB ._402_file-upload-section__wFJBR ._402_upload-grid__mQ-6R ._402_upload-item__S4T88 ._402_upload-placeholder__Cdh00 {
  padding: 12px;
  border: 2px dashed #ced4da;
  border-radius: 6px;
  background-color: white;
  text-align: center;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}
._402_form402-container__jy7gB ._402_file-upload-section__wFJBR ._402_upload-grid__mQ-6R ._402_upload-item__S4T88 ._402_upload-placeholder__Cdh00:hover {
  border-color: #007bff;
  color: #007bff;
  background-color: #f8f9fa;
}
._402_form402-container__jy7gB ._402_form-actions__G6VmQ {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
}
._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_submit-btn__ukjAx, ._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_print-btn__qvQ1Z {
  padding: 12px 30px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
}
._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_submit-btn__ukjAx {
  background: linear-gradient(135deg, #0467a0, #035a8a);
  color: white;
  box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);
}
._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_submit-btn__ukjAx:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(4, 103, 160, 0.4);
}
._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_submit-btn__ukjAx:active {
  transform: translateY(0);
}
._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_print-btn__qvQ1Z {
  background: linear-gradient(135deg, #ff0000, #cc0000);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);
}
._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_print-btn__qvQ1Z:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);
}
._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_print-btn__qvQ1Z:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  ._402_form402-container__jy7gB {
    margin: 10px;
    padding: 15px;
  }
  ._402_form402-container__jy7gB ._402_tab-navigation__jNXUi {
    flex-direction: column;
  }
  ._402_form402-container__jy7gB ._402_tab-navigation__jNXUi ._402_tab-button__GeA8c {
    padding: 15px 20px;
    font-size: 1rem;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 {
    padding: 20px;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU {
    padding: 20px;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP {
    height: 150px;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV ._402_signature-image__LDBel {
    max-height: 80px;
  }
  ._402_form402-container__jy7gB ._402_header__V1raK {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  ._402_form402-container__jy7gB ._402_header__V1raK ._402_logo__aI4Yu {
    margin-top: 0;
  }
  ._402_form402-container__jy7gB ._402_header__V1raK ._402_logo__aI4Yu ._402_logoImage__tFMe6 {
    width: 60px;
    height: 60px;
  }
  ._402_form402-container__jy7gB ._402_header__V1raK ._402_right__Yj5kK {
    position: static;
    text-align: right;
    margin-bottom: 10px;
  }
  ._402_form402-container__jy7gB ._402_header__V1raK ._402_center__l6Jye {
    margin: 15px 0;
  }
  ._402_form402-container__jy7gB ._402_mainTitle__8iTpY h1 {
    font-size: 20px;
  }
  ._402_form402-container__jy7gB ._402_formSection__r2VTK p {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  ._402_form402-container__jy7gB input[type=text]._402_underline__Zj3G\\+ {
    min-width: 100%;
  }
  ._402_form402-container__jy7gB ._402_table__wO45p {
    font-size: 12px;
  }
  ._402_form402-container__jy7gB ._402_table__wO45p th, ._402_form402-container__jy7gB ._402_table__wO45p td {
    padding: 6px;
    font-size: 12px;
  }
  ._402_form402-container__jy7gB ._402_signature__zT7Ao {
    flex-direction: column;
    gap: 20px;
  }
  ._402_form402-container__jy7gB ._402_signature__zT7Ao div {
    width: 100%;
  }
  ._402_form402-container__jy7gB ._402_deip__\\+j4Ag {
    flex-direction: column;
    gap: 10px;
  }
  ._402_form402-container__jy7gB ._402_file-upload-section__wFJBR ._402_upload-grid__mQ-6R {
    grid-template-columns: 1fr;
  }
  ._402_form402-container__jy7gB ._402_form-actions__G6VmQ {
    flex-direction: column;
    align-items: center;
  }
  ._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_submit-btn__ukjAx, ._402_form402-container__jy7gB ._402_form-actions__G6VmQ ._402_print-btn__qvQ1Z {
    width: 100%;
    max-width: 300px;
  }
}
@media (max-width: 480px) {
  ._402_form402-container__jy7gB {
    margin: 5px;
    padding: 10px;
  }
  ._402_form402-container__jy7gB ._402_header__V1raK ._402_logo__aI4Yu ._402_logoImage__tFMe6 {
    width: 50px;
    height: 50px;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP {
    height: 120px;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV ._402_signature-image__LDBel {
    max-height: 60px;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-preview__uKTvV p {
    font-size: 0.8rem;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-placeholder__2XED6 {
    font-size: 0.9rem;
  }
  ._402_form402-container__jy7gB ._402_signature-tab__-n819 ._402_signature-upload-section__Nsp-K ._402_signature-item__frXWU ._402_signature-upload-area__LgycD ._402_signature-upload-label__1iTnP ._402_signature-placeholder__2XED6 span {
    font-size: 1.5rem;
  }
  ._402_form402-container__jy7gB input[type=text] {
    min-width: 100px;
    font-size: 14px;
  }
  ._402_form402-container__jy7gB ._402_table__wO45p {
    font-size: 11px;
  }
  ._402_form402-container__jy7gB ._402_table__wO45p th, ._402_form402-container__jy7gB ._402_table__wO45p td {
    padding: 4px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StoreForm/402/402.module.scss"],"names":[],"mappings":"AAAA;EACE,sDAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,iBAAA;EACA,iBAAA;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,0EAAA;EACA,4BAAA;EACA,gBAAA;EACA,yCAAA;AAAJ;AAEI;EACE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,sDAAA;AAAN;AAEM;EACE,oCAAA;EACA,YAAA;EACA,2BAAA;AAAR;AAGM;EACE,oCAAA;EACA,YAAA;EACA,+BAAA;AADR;AAGQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AADV;AAQE;EACE,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,mBAAA;AANJ;AAQI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;AANN;AASI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAPN;AASM;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,yBAAA;EACA,6BAAA;AAPR;AASQ;EACE,2BAAA;EACA,2CAAA;EACA,qBAAA;AAPV;AAUQ;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,oBAAA;AARV;AAWQ;EACE,kBAAA;AATV;AAWU;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AATZ;AAYU;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAVZ;AAYY;EACE,qBAAA;EACA,mBAAA;EACA,sBAAA;AAVd;AAaY;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAXd;AAac;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AAXhB;AAeY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AAbd;AAec;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;AAbhB;AAgBc;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;AAdhB;AAiBc;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,sCAAA;EACA,WAAA;AAfhB;AAiBgB;EACE,mBAAA;AAflB;AAkBgB;EACE,aAAA;AAhBlB;AA0BE;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAxBJ;AA0BI;EACE,cAAA;EACA,gBAAA;AAxBN;AA0BM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AAxBR;AA4BI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;AA1BN;AA6BI;EACE,WAAA;AA3BN;AA8BI;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA,EAAA,8BAAA;AA5BN;AA8BM;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AA5BR;AA8BQ;EACE,eAAA;EACA,iBAAA;EACA,aAAA;AA5BV;AA+BQ;EACE,eAAA;EACA,mBAAA;AA7BV;AA+BU;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AA7BZ;AAiCQ;EACE,eAAA;EACA,mBAAA;AA/BV;AAiCU;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AA/BZ;AAmCQ;EACE,eAAA;EACA,mBAAA;AAjCV;AAmCU;EACE,mBAAA;AAjCZ;AAoCU;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,0BAAA;EACA,sBAAA;AAlCZ;AAwCI;EACE,aAAA;EACA,eAAA;AAtCN;AA0CE;EACE,kBAAA;EACA,cAAA;AAxCJ;AA0CI;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAxCN;AA4CE;EACE,cAAA;AA1CJ;AA4CI;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA1CN;AA8CE;EACE,YAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oDAAA;EACA,WAAA;AA5CJ;AA8CI;EACE,aAAA;EACA,4BAAA;AA5CN;AA+CI;EACE,mBAAA;AA7CN;AAgDI;EACE,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AA9CN;AAgDM;EACE,mBAAA;AA9CR;AAmDE;EACE,6BAAA;EACA,WAAA;EACA,cAAA;AAjDJ;AAoDE;EACE,yBAAA;EACA,WAAA;EACA,cAAA;AAlDJ;AAoDI;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAlDN;AAqDI;EACE,yBAAA;EACA,iBAAA;AAnDN;AAsDI;EACE,YAAA;AApDN;AAuDI;EACE,WAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AArDN;AAyDE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAvDJ;AAyDI;EACE,UAAA;EACA,gBAAA;AAvDN;AA0DI;EACE,gBAAA;EACA,kBAAA;AAxDN;AA0DM;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AAxDR;AA6DE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA3DJ;AA8DE;EACE,aAAA;AA5DJ;AA+DE;EACE,mBAAA;AA7DJ;AAgEE;EACE,gBAAA;AA9DJ;AAiEE;EACE,eAAA;EACA,gBAAA;AA/DJ;AAkEE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAhEJ;AAmEE;EACE,sBAAA;EACA,YAAA;AAjEJ;AAqEE;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;AAnEJ;AAqEI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAnEN;AAsEI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AApEN;AAsEM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AApER;AAsEQ;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AApEV;AAuEQ;EACE,aAAA;AArEV;AAwEQ;EACE,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAtEV;AAwEU;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;AAtEZ;AA8EE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AA5EJ;AA8EI;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AA5EN;AA+EI;EACE,qDAAA;EACA,YAAA;EACA,6CAAA;AA7EN;AA+EM;EACE,2BAAA;EACA,6CAAA;AA7ER;AAgFM;EACE,wBAAA;AA9ER;AAkFI;EACE,qDAAA;EACA,YAAA;EACA,2CAAA;AAhFN;AAkFM;EACE,2BAAA;EACA,2CAAA;AAhFR;AAmFM;EACE,wBAAA;AAjFR;;AAwFA;EACE;IACE,YAAA;IACA,aAAA;EArFF;EAuFE;IACE,sBAAA;EArFJ;EAuFI;IACE,kBAAA;IACA,eAAA;EArFN;EAyFE;IACE,aAAA;EAvFJ;EAyFI;IACE,0BAAA;IACA,SAAA;EAvFN;EAyFM;IACE,aAAA;EAvFR;EA0FU;IACE,aAAA;EAxFZ;EA2Fc;IACE,gBAAA;EAzFhB;EAkGE;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EAhGJ;EAkGI;IACE,aAAA;EAhGN;EAkGM;IACE,WAAA;IACA,YAAA;EAhGR;EAoGI;IACE,gBAAA;IACA,iBAAA;IACA,mBAAA;EAlGN;EAqGI;IACE,cAAA;EAnGN;EAuGE;IACE,eAAA;EArGJ;EAwGE;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAtGJ;EAyGE;IACE,eAAA;EAvGJ;EA0GE;IACE,eAAA;EAxGJ;EA0GI;IACE,YAAA;IACA,eAAA;EAxGN;EA4GE;IACE,sBAAA;IACA,SAAA;EA1GJ;EA4GI;IACE,WAAA;EA1GN;EA8GE;IACE,sBAAA;IACA,SAAA;EA5GJ;EAgHI;IACE,0BAAA;EA9GN;EAkHE;IACE,sBAAA;IACA,mBAAA;EAhHJ;EAkHI;IACE,WAAA;IACA,gBAAA;EAhHN;AACF;AAqHA;EACE;IACE,WAAA;IACA,aAAA;EAnHF;EAuHM;IACE,WAAA;IACA,YAAA;EArHR;EA8HU;IACE,aAAA;EA5HZ;EA+Hc;IACE,gBAAA;EA7HhB;EAgIc;IACE,iBAAA;EA9HhB;EAkIY;IACE,iBAAA;EAhId;EAkIc;IACE,iBAAA;EAhIhB;EAyIE;IACE,gBAAA;IACA,eAAA;EAvIJ;EA0IE;IACE,eAAA;EAxIJ;EA0II;IACE,YAAA;IACA,eAAA;EAxIN;AACF","sourcesContent":[".form402-container {\n  font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n  margin: 20px;\n  padding: 20px;\n  background-color: #fff;\n  color: #000;\n  line-height: 1.6;\n  direction: ltr;\n  text-align: left;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 1200px;\n  margin: 20px auto;\n\n  // Tab Navigation\n  .tab-navigation {\n    display: flex;\n    margin-bottom: 30px;\n    border-bottom: 2px solid #e9ecef;\n    background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);\n    border-radius: 12px 12px 0 0;\n    overflow: hidden;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n    .tab-button {\n      flex: 1;\n      padding: 20px 30px;\n      background: transparent;\n      border: none;\n      color: rgba(255, 255, 255, 0.8);\n      font-size: 1.1rem;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      position: relative;\n      font-family: 'Noto Sans Devanagari', Arial, sans-serif;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.1);\n        color: white;\n        transform: translateY(-2px);\n      }\n\n      &.active {\n        background: rgba(255, 255, 255, 0.2);\n        color: white;\n        box-shadow: inset 0 -3px 0 #fff;\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: 3px;\n          background: #fff;\n          border-radius: 2px;\n        }\n      }\n    }\n  }\n\n  // Signature Tab Styles\n  .signature-tab {\n    padding: 30px;\n    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    border-radius: 12px;\n    margin-bottom: 30px;\n\n    h2 {\n      text-align: center;\n      color: #2c3e50;\n      font-size: 2rem;\n      margin-bottom: 30px;\n      font-weight: 700;\n      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    }\n\n    .signature-upload-section {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n      gap: 30px;\n      margin-top: 20px;\n\n      .signature-item {\n        background: white;\n        border-radius: 15px;\n        padding: 25px;\n        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n        transition: all 0.3s ease;\n        border: 2px solid transparent;\n\n        &:hover {\n          transform: translateY(-5px);\n          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);\n          border-color: #0467a0;\n        }\n\n        h3 {\n          color: #2c3e50;\n          font-size: 1.3rem;\n          margin-bottom: 20px;\n          text-align: center;\n          font-weight: 600;\n          border-bottom: 2px solid #e9ecef;\n          padding-bottom: 10px;\n        }\n\n        .signature-upload-area {\n          position: relative;\n\n          input[type=\"file\"] {\n            position: absolute;\n            opacity: 0;\n            width: 100%;\n            height: 100%;\n            cursor: pointer;\n            z-index: 2;\n          }\n\n          .signature-upload-label {\n            display: block;\n            cursor: pointer;\n            width: 100%;\n            height: 200px;\n            border: 3px dashed #dee2e6;\n            border-radius: 12px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: all 0.3s ease;\n            background: #f8f9fa;\n            position: relative;\n            overflow: hidden;\n\n            &:hover {\n              border-color: #667eea;\n              background: #f0f4ff;\n              transform: scale(1.02);\n            }\n\n            .signature-placeholder {\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n              justify-content: center;\n              color: #6c757d;\n              font-size: 1.1rem;\n              font-weight: 500;\n              text-align: center;\n              padding: 20px;\n\n              span {\n                font-size: 2rem;\n                margin-bottom: 10px;\n                opacity: 0.7;\n              }\n            }\n\n            .signature-preview {\n              width: 100%;\n              height: 100%;\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n              justify-content: center;\n              padding: 15px;\n              position: relative;\n\n              .signature-image {\n                max-width: 100%;\n                max-height: 120px;\n                object-fit: contain;\n                border-radius: 8px;\n                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n                margin-bottom: 10px;\n                border: 2px solid #e9ecef;\n                background: white;\n                padding: 5px;\n              }\n\n              p {\n                color: #495057;\n                font-size: 0.9rem;\n                font-weight: 500;\n                text-align: center;\n                margin: 0;\n                word-break: break-word;\n                max-width: 100%;\n              }\n\n              .delete-signature-btn {\n                position: absolute;\n                top: -8px;\n                right: -8px;\n                width: 24px;\n                height: 24px;\n                border-radius: 50%;\n                background: #ff4444;\n                color: white;\n                border: none;\n                cursor: pointer;\n                font-size: 12px;\n                font-weight: bold;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n                transition: background-color 0.2s ease;\n                z-index: 10;\n\n                &:hover {\n                  background: #cc0000;\n                }\n\n                &:focus {\n                  outline: none;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .header {\n    margin-bottom: 30px;\n    position: relative;\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n    \n    .logo {\n      flex-shrink: 0;\n      margin-top: 10px;\n      \n      .logoImage {\n        width: 100px;\n        height: 100px;\n        object-fit: contain;\n        border-radius: 50%;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n      }\n    }\n    \n    .right {\n      position: absolute;\n      top: 0;\n      right: 0;\n      font-size: 12px;\n      font-weight: bold;\n    }\n\n    .clear {\n      clear: both;\n    }\n\n    .center {\n      text-align: center;\n      margin: 20px 0;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      flex: 1;\n      margin-left: -180px; /* Shift content to the left */\n\n      p {\n        margin: 3px 0;\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 1.0;\n        text-align: center;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        \n        &.universityName {\n          font-size: 18px;\n          font-weight: bold;\n          margin: 5px 0;\n        }\n        \n        &.officeName {\n          font-size: 16px;\n          font-weight: normal;\n          \n          input {\n            font-size: 16px;\n            font-weight: normal;\n            text-align: center;\n          }\n        }\n        \n        &.officeAddress {\n          font-size: 16px;\n          font-weight: normal;\n          \n          input {\n            font-size: 16px;\n            font-weight: normal;\n            text-align: center;\n          }\n        }\n        \n        &.officeCode {\n          font-size: 16px;\n          font-weight: normal;\n          \n          span {\n            white-space: nowrap;\n          }\n          \n          input {\n            font-size: 16px;\n            font-weight: normal;\n            text-align: center;\n            min-width: 30px !important;\n            max-width: 30px !important;\n            width: 30px !important;\n          }\n        }\n      }\n    }\n\n    p {\n      margin: 8px 0;\n      font-size: 14px;\n    }\n  }\n\n  .mainTitle {\n    text-align: center;\n    margin: 30px 0;\n    \n    h1 {\n      font-size: 24px;\n      font-weight: bold;\n      margin: 0;\n      color: #000;\n    }\n  }\n\n  .formSection {\n    margin: 20px 0;\n    \n    p {\n      margin: 12px 0;\n      font-size: 14px;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n\n  input[type=\"text\"] {\n    border: none;\n    border-bottom: 1px solid #000;\n    min-width: 80px;\n    max-width: 400px;\n    background: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    text-align: left;\n    margin: 0 2px;\n    padding: 2px 4px;\n    overflow: visible;\n    white-space: nowrap;\n    transition: border-bottom 0.2s ease, width 0.2s ease;\n    width: auto;\n    \n    &:focus {\n      outline: none;\n      border-bottom-color: #007bff;\n    }\n    \n    &:not(:placeholder-shown) {\n      border-bottom: none;\n    }\n\n    &.underline {\n      border-bottom: 1px solid #000;\n      min-width: 120px;\n      max-width: 500px;\n      flex: 1;\n      \n      &:not(:placeholder-shown) {\n        border-bottom: none;\n      }\n    }\n  }\n\n  .underline {\n    border-bottom: 1px solid #000;\n    width: 100%;\n    margin: 10px 0;\n  }\n\n  .table {\n    border-collapse: collapse;\n    width: 100%;\n    margin: 20px 0;\n    \n    th, td {\n      border: 1px solid #000;\n      padding: 10px;\n      text-align: center;\n      vertical-align: middle;\n      font-size: 14px;\n    }\n    \n    th {\n      background-color: #f2f2f2;\n      font-weight: bold;\n    }\n    \n    tbody tr {\n      height: 40px;\n    }\n    \n    input[type=\"text\"] {\n      width: 100%;\n      box-sizing: border-box;\n      min-width: auto;\n      margin: 0;\n      border: none;\n      text-align: center;\n    }\n  }\n\n  .signature {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 40px;\n    \n    div {\n      width: 30%;\n      text-align: left;\n    }\n\n    .signature-display {\n      margin-top: 10px;\n      text-align: center;\n      \n      img {\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        background: white;\n        padding: 2px;\n      }\n    }\n  }\n\n  .page-number {\n    text-align: center;\n    margin-top: 50px;\n    font-size: 12px;\n    color: #666;\n  }\n\n  p {\n    margin: 5px 0;\n  }\n\n  .form-section {\n    margin-bottom: 20px;\n  }\n\n  .total-section {\n    margin-top: 10px;\n  }\n\n  .notes {\n    font-size: 12px;\n    margin-top: 10px;\n  }\n\n  .deip {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n  }\n\n  .ddd {\n    border: 1px solid #000;\n    padding: 4px;\n  }\n\n  // File Upload Section\n  .file-upload-section {\n    margin: 30px 0;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    border: 2px dashed #dee2e6;\n\n    h3 {\n      margin: 0 0 20px 0;\n      color: #333;\n      font-size: 18px;\n      text-align: center;\n    }\n\n    .upload-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n      gap: 20px;\n\n      .upload-item {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        label {\n          font-weight: 600;\n          color: #495057;\n          font-size: 14px;\n        }\n\n        input[type=\"file\"] {\n          display: none;\n        }\n\n        .upload-placeholder {\n          padding: 12px;\n          border: 2px dashed #ced4da;\n          border-radius: 6px;\n          background-color: white;\n          text-align: center;\n          color: #6c757d;\n          cursor: pointer;\n          transition: all 0.3s ease;\n          font-size: 14px;\n\n          &:hover {\n            border-color: #007bff;\n            color: #007bff;\n            background-color: #f8f9fa;\n          }\n        }\n      }\n    }\n  }\n\n  // Form Actions\n  .form-actions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 40px;\n    padding: 20px 0;\n    border-top: 1px solid #dee2e6;\n\n    .submit-btn, .print-btn {\n      padding: 12px 30px;\n      border: none;\n      border-radius: 25px;\n      font-size: 16px;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      min-width: 150px;\n    }\n\n    .submit-btn {\n      background: linear-gradient(135deg, #0467a0, #035a8a);\n      color: white;\n      box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 6px 20px rgba(4, 103, 160, 0.4);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n    }\n\n    .print-btn {\n      background: linear-gradient(135deg, #ff0000, #cc0000);\n      color: white;\n      box-shadow: 0 4px 15px rgba(255, 0, 0, 0.3);\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 6px 20px rgba(255, 0, 0, 0.4);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .form402-container {\n    margin: 10px;\n    padding: 15px;\n\n    .tab-navigation {\n      flex-direction: column;\n\n      .tab-button {\n        padding: 15px 20px;\n        font-size: 1rem;\n      }\n    }\n\n    .signature-tab {\n      padding: 20px;\n\n      .signature-upload-section {\n        grid-template-columns: 1fr;\n        gap: 20px;\n\n        .signature-item {\n          padding: 20px;\n\n          .signature-upload-area {\n            .signature-upload-label {\n              height: 150px;\n\n              .signature-preview {\n                .signature-image {\n                  max-height: 80px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .header {\n      flex-direction: column;\n      align-items: center;\n      gap: 15px;\n      \n      .logo {\n        margin-top: 0;\n        \n        .logoImage {\n          width: 60px;\n          height: 60px;\n        }\n      }\n      \n      .right {\n        position: static;\n        text-align: right;\n        margin-bottom: 10px;\n      }\n\n      .center {\n        margin: 15px 0;\n      }\n    }\n\n    .mainTitle h1 {\n      font-size: 20px;\n    }\n\n    .formSection p {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 5px;\n    }\n\n    input[type=\"text\"].underline {\n      min-width: 100%;\n    }\n\n    .table {\n      font-size: 12px;\n      \n      th, td {\n        padding: 6px;\n        font-size: 12px;\n      }\n    }\n\n    .signature {\n      flex-direction: column;\n      gap: 20px;\n      \n      div {\n        width: 100%;\n      }\n    }\n\n    .deip {\n      flex-direction: column;\n      gap: 10px;\n    }\n\n    .file-upload-section {\n      .upload-grid {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .form-actions {\n      flex-direction: column;\n      align-items: center;\n      \n      .submit-btn, .print-btn {\n        width: 100%;\n        max-width: 300px;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .form402-container {\n    margin: 5px;\n    padding: 10px;\n\n    .header {\n      .logo {\n        .logoImage {\n          width: 50px;\n          height: 50px;\n        }\n      }\n    }\n\n    .signature-tab {\n      .signature-upload-section {\n        .signature-item {\n          .signature-upload-area {\n            .signature-upload-label {\n              height: 120px;\n\n              .signature-preview {\n                .signature-image {\n                  max-height: 60px;\n                }\n\n                p {\n                  font-size: 0.8rem;\n                }\n              }\n\n              .signature-placeholder {\n                font-size: 0.9rem;\n\n                span {\n                  font-size: 1.5rem;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    input[type=\"text\"] {\n      min-width: 100px;\n      font-size: 14px;\n    }\n\n    .table {\n      font-size: 11px;\n      \n      th, td {\n        padding: 4px;\n        font-size: 11px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form402-container": `_402_form402-container__jy7gB`,
	"tab-navigation": `_402_tab-navigation__jNXUi`,
	"tab-button": `_402_tab-button__GeA8c`,
	"active": `_402_active__Jp02j`,
	"signature-tab": `_402_signature-tab__-n819`,
	"signature-upload-section": `_402_signature-upload-section__Nsp-K`,
	"signature-item": `_402_signature-item__frXWU`,
	"signature-upload-area": `_402_signature-upload-area__LgycD`,
	"signature-upload-label": `_402_signature-upload-label__1iTnP`,
	"signature-placeholder": `_402_signature-placeholder__2XED6`,
	"signature-preview": `_402_signature-preview__uKTvV`,
	"signature-image": `_402_signature-image__LDBel`,
	"delete-signature-btn": `_402_delete-signature-btn__FL-t9`,
	"header": `_402_header__V1raK`,
	"logo": `_402_logo__aI4Yu`,
	"logoImage": `_402_logoImage__tFMe6`,
	"right": `_402_right__Yj5kK`,
	"clear": `_402_clear__x1n+p`,
	"center": `_402_center__l6Jye`,
	"universityName": `_402_universityName__XWwb6`,
	"officeName": `_402_officeName__bgP4G`,
	"officeAddress": `_402_officeAddress__TRGCw`,
	"officeCode": `_402_officeCode__dyBTw`,
	"mainTitle": `_402_mainTitle__8iTpY`,
	"formSection": `_402_formSection__r2VTK`,
	"underline": `_402_underline__Zj3G+`,
	"table": `_402_table__wO45p`,
	"signature": `_402_signature__zT7Ao`,
	"signature-display": `_402_signature-display__60l0a`,
	"page-number": `_402_page-number__xZZKY`,
	"form-section": `_402_form-section__B9-K3`,
	"total-section": `_402_total-section__i7kdi`,
	"notes": `_402_notes__zevqe`,
	"deip": `_402_deip__+j4Ag`,
	"ddd": `_402_ddd__lCA6x`,
	"file-upload-section": `_402_file-upload-section__wFJBR`,
	"upload-grid": `_402_upload-grid__mQ-6R`,
	"upload-item": `_402_upload-item__S4T88`,
	"upload-placeholder": `_402_upload-placeholder__Cdh00`,
	"form-actions": `_402_form-actions__G6VmQ`,
	"submit-btn": `_402_submit-btn__ukjAx`,
	"print-btn": `_402_print-btn__qvQ1Z`
};
export default ___CSS_LOADER_EXPORT___;
